import { createRoute, dynamicWrapper } from "@/utils/core";

const routesConfig = app => ({
    path: "/home/index",
    title: '首页',
    component: dynamicWrapper(
        app,
        [
            import("./model/index"),
            import("./model/baseModel/index"),
            import("./model/linkageModel"),
            import("./model/config"),
            import("./model/device"),
            import("./model/organs"),
            import("./model/user"),
            import("./model/product"),
            import("./model/planePicture"),
            import("./model/planePosition"),
            import("./model/prospect"),
            import("./model/grid"),
        ],
        () => import("./components/index")
    )
});

export default app => createRoute(app, routesConfig);
